import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-overlays',
  imports: [
    Toast,
    ConfirmDialog,
  ],
  template: `
    <p-toast />
    <p-confirmDialog
      styleClass="confirm-dialog-screen-inset"
      [closable]="false"
      [dismissableMask]="false"
      [closeOnEscape]="false"
      [blockScroll]="true"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppOverlaysComponent {}
